import { Breadcrumbs, Button, Grid, Paper, TextField } from "@mui/material";
import { useRef, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ScopeHeader from "components/ScopeHeader";
import { ReactComponent as SmallWerke } from "assets/Svgs/smallWerke.svg";
import DeleteForeverOutlinedIcon from "@mui/icons-material/DeleteForeverOutlined";
import "247factorynet-packages/dist/index.css";

import i18n from "i18n/i18n";
import DeletePopUp from "components/DeletePopup";
import { useBoundStore } from "store/store";


function CreateArea() {
  let location = useLocation();

  const areaNameRef:any = useRef();

  const loadTopology: any = useBoundStore((state) => state.loadTopology);
  const legalEntityNodeId = useBoundStore((state) => state.legalEntityNodeId);

  const [areaName, setAreaName] = useState(location?.state?.name !== undefined ? location?.state?.name : "");
  const [areaid, setAreaId] = useState(location?.state?.areaid);
  const [order, setOrder] = useState(location?.state?.order !== undefined ? location?.state?.order : 0);

  const lang = useBoundStore((store) => store.lang);
  const isAuthUser = useBoundStore((store) => store.isAuthUser);

  const [searchParams, setSearchParams] = useSearchParams();

  let editMode = searchParams.get("nodeid") !== null;

  const navigate = useNavigate();

  const [openDialogDelete, setopenDialogDelete] = useState(false);

  const createAreaConfig = useBoundStore((state) => state.createAreaConfig);

  const updateAreaConfig = useBoundStore((state) => state.updateAreaConfig);


  const deleteAreaConfiguration: any = useBoundStore(
    (state) => state.deleteAreaConfiguration
  );

  let sitenodeid = location.state.sitenodeid;


  const handleDialogDelete = () => {
    setopenDialogDelete(false);
  };


  const handleCreateArea = async () => {
    if (areaName === "" || areaName === undefined) {
      areaNameRef.current.focus();
      return;
    }

    let obj = {
      lang: lang,
      name: areaName,
      sitenodeid: location.state.nodeid,
      areaid: areaid,
      order: order,
      legalentitynodeid:legalEntityNodeId
    };

    const promises = await createAreaConfig(obj);
    if (isAuthUser === true) {
      try {
        const result = await Promise.all(promises);
        navigate("/sites?sitenodeid=" + location.state.nodeid);
        setTimeout(async ()=>{
          await loadTopology(lang);
         },2000)

      } catch (error) {
        console.error("Error during promise execution:", error);
      }
    }
  };

  const handleUpdateArea = async () => {

    if(areaName === ""){
      areaName.current.focus();
        return;
      }

    const promises = await  updateAreaConfig(location.state.nodeid,{
      lang: lang,
      name: areaName,
      areaid: areaid,
      order: order,
      legalentitynodeid:legalEntityNodeId
    });

    if (isAuthUser === true) {
      try {
        const result = await Promise.all(promises);
        navigate("/sites?sitenodeid=" + sitenodeid);

        await loadTopology(lang);
      } catch (error) {
        console.error("Error during promise execution:", error);
      }
    }
  };

  const handleDelete = () => {

    deleteAreaConfiguration({ areanodeid: location.state.nodeid,legalEntityNodeId:legalEntityNodeId });
    navigate("/sites?sitenodeid=" + sitenodeid);
    setTimeout(async ()=>{
      await loadTopology(lang);
     },2000)
  };

  return (
    <>
      <Breadcrumbs aria-label="breadcrumb">
        <div
          onClick={() => {
            navigate(-1);
          }}
          style={{
            color: "rgba(0, 0, 0, 0.38)",
            display: "flex",
            cursor: "pointer",
            margin: "15px 0px",
          }}
        >
          <ArrowBackIcon />
          {i18n(lang).backLink}
        </div>
      </Breadcrumbs>

      <ScopeHeader
        bgColor="#B21412"
        bgImage="images/scope_header.png"
        txtColor="#FFFFFF"
        title={i18n(lang).area_scope_title}
        description={i18n(lang).area_scope_description}
      />

      <Paper sx={{ padding: "24px" }}>
        <div className="createSite">
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div
              style={{
                display: "flex",
              }}
            >
              <div>
                <SmallWerke fontSize={5} />
              </div>
              <div className="smallCaption">{location?.state?.sitename}</div>
            </div>

            <div>
              {editMode ? (
                <Button
                  variant="contained"
                  color="error"
                  size="large"
                  startIcon={<DeleteForeverOutlinedIcon />}
                  onClick={() => {
                    setopenDialogDelete(true);
                  }}
                  sx={{
                    width: "100%",
                    color: "rgba(255, 61, 0, 1)",
                    border: "1px solid rgba(0, 0, 0, 0.12)",
                    borderRadius: "4px",
                    background: "#ffffff",
                    ":hover": { color: "#ffffff" },
                    boxShadow: "none",
                  }}
                >
                 
                  {i18n(lang).area_delete}
                </Button>
              ) : (
                ""
              )}
            </div>
          </div>

          <div className="_title">{i18n(lang).create_new_area}</div>

          <Grid container spacing={2} sx={{ margin: "20px 0px" }}>
            <Grid item xs={5} style={{ padding: 0 }}>
              <TextField
                value={areaName}
                fullWidth
                onChange={(e) => {
                  setAreaName(e.target.value);
                }}
                error={areaName === ""}
                inputRef={areaNameRef}
                label={i18n(lang).areaname}
                variant="outlined"
                helperText={i18n(lang).create_area_helper_text}
              />
            </Grid>
            <Grid item xs={5} style={{ padding: 0 }}>
              <TextField
                sx={{ marginLeft: "20px" }}
                value={order}
                type="number"
                InputProps={{ inputProps: { min: 1, max:100 } }}
                fullWidth
                onChange={(e) => {
                  setOrder(parseInt(e.target.value, 10));
                }}
                label={i18n(lang).area_order_number}
                variant="outlined"
              /> 
            </Grid>
            
          </Grid>
        </div>
      </Paper>

      <DeletePopUp
        open={openDialogDelete}
        handleClose={handleDialogDelete}
        handleDelete={handleDelete}
      ></DeletePopUp>

      <Button
        sx={{ margin: "20px 0px" }}
        variant="contained"
        onClick={() => {
          editMode ? handleUpdateArea() : handleCreateArea();
        }}
        disabled={areaName === ""}
      >
       {i18n(lang).create_an_area}
      </Button>
    </>
  );
}

export default CreateArea;
